import { render, staticRenderFns } from "./CheckAfterPackAdd.vue?vue&type=template&id=b2ae1c6c&scoped=true&"
import script from "./CheckAfterPackAdd.vue?vue&type=script&lang=js&"
export * from "./CheckAfterPackAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ae1c6c",
  null
  
)

export default component.exports